export enum CertificateTypesRegistration {
  MEMBERSHIP = 'ZTSH Membership',
}
